import type { SingleRecordResponse, Redirect } from '../types'
import { DEFAULT_REDIRECT_URI } from '../shared/constants'
import { useRedirectApiUrl } from './useRedirectApiUrl'
import { useClient } from './useClient'

export const useRedirectApi = () => {
  const baseUrl = useRedirectApiUrl()

  if (!baseUrl) {
    throw new Error('Redirect base url is not set.')
  }

  const { public: { redirectUri = DEFAULT_REDIRECT_URI } } = useRuntimeConfig()

  const view = (sourceUrl: string) => {
    return useClient<SingleRecordResponse<Redirect.Model>>(baseUrl, redirectUri, {
      method: 'GET',
      params: {
        url: sourceUrl,
      },
    })
  }

  return { view }
}
